// extracted by mini-css-extract-plugin
module.exports = {"root":"container_root__2Z2xB"};